import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(
  amount: number | string | null | undefined,
  currency = "NGN",
  maximumFractionDigits = 0,
) {
  const value =
    typeof amount === "string" ? Number.parseFloat(amount) : (amount ?? 0);
  if (!Number.isFinite(value)) {
    return "₦0";
  }

  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(value);
}

export function formatCompactCurrency(value: number) {
  if (!Number.isFinite(value)) {
    return "₦0";
  }

  if (Math.abs(value) >= 1_000_000_000) {
    return `₦${(value / 1_000_000_000).toFixed(1)}B`;
  }
  if (Math.abs(value) >= 1_000_000) {
    return `₦${(value / 1_000_000).toFixed(1)}M`;
  }
  if (Math.abs(value) >= 1_000) {
    return `₦${(value / 1_000).toFixed(0)}K`;
  }

  return `₦${value.toLocaleString()}`;
}

export function formatEnumLabel(value: string | null | undefined) {
  if (!value) {
    return "N/A";
  }

  return value
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function initialsFromName(name: string | null | undefined) {
  const safeName = name?.trim();
  if (!safeName) {
    return "LN";
  }

  return safeName
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}